export default {"src":"/_next/static/media/info_icon_dark_orange.d95efe93.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};